
import { APP_INITIALIZER, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CdcModule } from '@spartacus/cdc';
import { CdcRootModule } from '@spartacus/cdc/root';
import { LanguageInitializer, provideConfig } from '@spartacus/core';
import { AppRoutingModule, PWAModuleConfig } from '@spartacus/storefront';
import { ToastrModule } from 'ngx-toastr';
import { StartupService } from './core/services/start-up.service';
import { CustomHeaderFooterModule } from './modules/custom-header-footer/custom-header-footer.module';
import { CustomLandingModule } from './modules/custom-landing/custom-landing.module';
import { CustomLoginModule } from './modules/custom-login/custom-login.module';
import { CustomRoutingModule } from './modules/custom-routing/custom-routing.module';
import { LogoutModule } from './modules/logout/logout.module';
import { SpartacusModule } from './spartacus/spartacus.module';
export function startupServiceFactory(startupService: StartupService): Function {
  return (): Promise<any> => {
    return startupService.load();
  };
}

@NgModule({
  imports: [
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    // OAuthModule,
    SpartacusModule,
    CdcRootModule, CdcModule,
    CustomLandingModule,
    CustomRoutingModule,
    CustomHeaderFooterModule,
    CustomLoginModule,
    LogoutModule,
    ToastrModule.forRoot({
      timeOut: 2500,
      positionClass: 'toast-bottom-center',
      toastClass: 'custom-toast ',
      preventDuplicates: true,
    }),
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule
  ],
  bootstrap: [],
  providers: [
    LanguageInitializer,
    Title,
    //OAuthService,
    StartupService,
    {
      // Provider for APP_INITIALIZER
      provide: APP_INITIALIZER,
      useFactory: startupServiceFactory,
      deps: [StartupService],
      multi: true
    }, provideConfig(<PWAModuleConfig>{
      pwa: {
        enabled: true,
        addToHomeScreen: true
      }
    })
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule { }
